/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
type ColumnKeys = 'name' | 'uploadType' | 'lastUpdated' | 'status';


const AuditColumns: React.FC<{ sortData: (key: string) => void, sortConfig: { key: string, direction: string } }> = ({ sortData, sortConfig }) => {
  const [ svgIcons, setSvgIcons ] = useState<Record<ColumnKeys, JSX.Element>>({
    name: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='#BDBEC1'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    uploadType: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='#BDBEC1'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    lastUpdated: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='#BDBEC1'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    status: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='#BDBEC1'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
  });

  useEffect(() => {
    const newSvgIcons = { ...svgIcons };

    // Update the SVG icons based on the sorting state
    (Object.keys(newSvgIcons) as ColumnKeys[]).forEach((column) => { // Cast keys to ColumnKeys[]
      if (column === sortConfig.key) {
        newSvgIcons[column] = sortConfig.direction === 'asc' ? (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='#BDBEC1'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 3.33331V12.6666M7.99967 12.6666L3.33301 7.99998M7.99967 12.6666L12.6663 7.99998'
              stroke='#BDBEC1'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      } else {
        // Reset the icon to the default state
        newSvgIcons[column] = (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='#BDBEC1'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      }
    });

    setSvgIcons(newSvgIcons);
  }, [ sortConfig ]);

  const getSortIndicator = (key: string) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? (
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
          <path
            d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
            stroke='#BDBEC1'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      ) : (
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
          <path
            d='M7.99967 3.33331V12.6666M7.99967 12.6666L3.33301 7.99998M7.99967 12.6666L12.6663 7.99998'
            stroke='#BDBEC1'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
        <path
          d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
          stroke='#BDBEC1'
          strokeWidth='1.33333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  };


  return (
    <div className='screening-results-columns'>
      {/* <div className='screening-table-placeholder-column'></div> */}
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner' >
          <div className='screening-table-column-text'>
          Name

          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
          Upload Type

          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
              Total Results

          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
              Status

          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
          Last Updated

          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditColumns;
